<template>
  <div>
    <div
      class="innerBox"
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 7.5px 10px;
      "
    >
      <button
        class="btn"
        style="font-size: 16px; color: #6c6c6c; font-weight: bold; padding: 4px"
        @click="$router.go(-1)"
      >
        <i class="fas fa-angle-left mr-2"></i>Back
      </button>
      <p class="mb-0" style="font-size: 16px; color: #b9b9b9; font-weight: 600">
        | Register Muat <i class="fas fa-angle-right"></i>
      </p>
      <p
        class="mb-0 ml-1"
        style="font-size: 16px; color: #4b4b4b; font-weight: bold"
      >
        {{ mode == "CREATE" ? "Create" : "Edit" }} Muatan
      </p>
    </div>

    <!-- Your content goes here -->
    <form>
      <div class="innerBox col mt-4">
        <h2
          class="form-box__title"
        >
          Data Input
        </h2>
        <div class="row mt-3 f-25">
          <div class="col-3">
            <label class="form-label">Region</label>
          </div>
          <div class="col-9">
            <div style="display: flex; flex-direction: row; margin-left: 20px">
              <div
                v-for="item in region"
                :key="item"
                style="margin-right: 50px"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  :value="item"
                  v-model="form.region"
                />
                <label class="form-check-label">
                  {{ item }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 f-25">
          <div class="col-3">
            <label class="form-label">Register Muat</label>
          </div>
          <div class="col-3">
            <div class="input-group">
              <flat-pickr
                :config="rangePickr"
                placeholder="Pilih Tanggal"
                v-model="form.register_muat"
              ></flat-pickr>
              <div class="input-group-append">
                <span
                  class="input-group-text bg-white border-left-0"
                  style="
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 f-25">
          <div class="col-3">
            <label class="form-label">Plant Tujuan</label>
          </div>
          <div class="col-9">
            <div style="display: flex; flex-direction: row; margin-left: 20px">
              <div
                v-for="item in plant"
                :key="item.id"
                style="margin-right: 50px"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  :value="item.id"
                  v-model="form.plant"
                />
                <label class="form-check-label">
                  {{ item.plant_name }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 f-25">
          <div class="col-3">
            <label class="form-label">Nopol</label>
          </div>
          <div class="col-3">
            <div class="search-container">
              <div class="dropdown-container">
                <Multiselect
                  :options="truck.map((truck) => truck.nopol)"
                  placeholder="Nopol"
                  v-model="selectedNopol"
                  class="tms-multiselect"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 f-25">
          <div class="col-3">
            <label class="form-label">Kapasitas</label>
          </div>
          <div class="col-6">
            <input
              type="text"
              v-model="form.capacity"
              class="searchbar"
              placeholder="Kapasitas"
              @input="restrictToNumbers"
            />
          </div>
        </div>

        <div class="filter row">
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6"></div>
          <div class="col-lg-2 col-md-6">
            <button
              type="button"
              class="btn btn-primary w-100"
              style="font-size: 100%"
              @click="submitForm()"
            >
              Simpan
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
// import DateRangePicker from 'vue-daterange-picker';

export default {
  metaInfo: {
    title: "Create Muatan",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    return {
      mode: "CREATE",
      updateId: null,

      region: [],
      plant: [],
      truck: [],
      selectedNopol: null,
      filter: {
        start: startDate,
        end: currentDate,
        truck: null,
        region: null,
        plant: null,
      },
      form: {
        region: "",
        register_muat: "",
        plant: "",
        truck: "",
        capacity: "",
      },
      rangePickr: {
        // mode: 'range',
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input grey-flatpickr",
        minDate: new Date()
      },
      selected: {
        dateButtonsIndex: 2,
        date: `${startDate}`,
      },
      selectedDate: null, // Use this for selected date
      selectedSearchResult: null, // Use this for selected search result
      searchQuery: "", // Use this for search input
      searchResults: [
        // Dummy search suggestions
        { value: "Pilih Nopol" },
        { value: "Pilih Nopol" },
        // Add more options as needed
      ],
    };
  },
  components: {
    Multiselect,
  },
  created() {
    this.$http
      .get("/api/master/truck")
      .then((resp) => {
        this.truck = resp.data.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    this.region = this.$store.getters.getRegion.filter(val => val !== 'All');
    this.plant = this.$store.getters.getPlant;

    let routerName = this.$route.name;
    let editData = this.$route.params.data;
    console.log("%cCUMuat.vue line:217 editData", "color: #007acc;", editData);

    if (routerName == "UMuat") {
      if (editData != null) {
        this.mode = "UPDATE";
        this.form.region = editData.region;
        this.form.register_muat = editData.register_muat;
        this.form.plant = editData.plant_id;
        this.form.truck = editData.truck_id;
        this.form.capacity = editData.capacity;
        this.selectedNopol = editData.nopol;

        this.updateId = editData.id;
      } else {
        //No Data, No View Page
        this.$router.go(-1);
      }
    }
  },
  watch: {
    selectedNopol(newNopol) {
      // Find the corresponding "id" based on the selected "nopol"
      const selectedTruck = this.truck.find((item) => item.nopol === newNopol);
      if (selectedTruck) {
        this.form.truck = selectedTruck.id;
      }
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];

      //Check End
      if (this.filter.end != moment().format("YYYY-MM-DD")) {
        this.selected.dateButtonsIndex = -1;
        //Check Start
      } else if (
        this.options.dateButtons
          .map((x) => x.start)
          .indexOf(this.rangePickr.start) == -1
      ) {
        this.selected.dateButtonsIndex = -1;
        //Found Match
      } else {
        this.selected.dateButtonsIndex = this.options.dateButtons
          .map((x) => x.start)
          .indexOf(this.rangePickr.start);
      }
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
  },
  methods: {
    restrictToNumbers(event) {
      // Remove non-numeric characters from the input value
      this.form.capacity = event.target.value.replace(/[^0-9]/g, "");
    },
    goBack() {
      this.$router.go(-1); // Go back to the previous route
    },
    performSearch() {
      // Implement your search logic here using this.searchQuery
      // For example, you can filter your data based on the search query
    },
    submitForm() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: `You are about to ${
            this.mode == "CREATE" ? "make a new" : "edit current"
          } data`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Simpan",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let url =
              this.mode == "CREATE"
                ? "/api/register-muat/save"
                : "/api/register-muat/update/" + this.updateId;
            let method = this.mode == "CREATE" ? "post" : "put";

            this.$http[method](url, this.form)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `${
                    this.mode == "CREATE" ? "Tambah" : "Ubah"
                  } register muat berhasil disimpan`,
                });
                this.$router.go(-1); // Go back to the previous route
              })
              .catch((error) => {
                console.log(
                  "%cerror DashboardUserUM.vue line:78 ",
                  "color: red; display: block; width: 100%;",
                  error
                );
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: error.response.data.message,
                });
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  padding-left: 40px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #4d4d4d;
}

/* .center {
          padding: 50px 20px;
          display: flexbox;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
  display: flex;
  align-items: center;
}

.dropdown-container {
  flex: 1;
  margin-right: 10px;
}

.searchbar-container {
  flex: 2;
}

.dropdown {
  width: 100%;
}

.searchbar {
  width: 47%;
  padding: 5px;
}
</style>
